import moment from "jalali-moment";
import React, { useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { GenderRender, RenderPrice } from "../../Function";
import BoxShadow from "../BoxShadow";
import Loading from "../Loading";
import { useTableWeek } from "./Hooks";
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import { Color } from "../../../../Utils/styles";
const EditTimeTable = ({
  id,
  needName,
  edit = {},
  contract = {},
  multi = {},
  range = {},
  status = false,
  status2,
  isApp,
  contractPage
}) => {
  const { loadingWeek, week, getWeek, days, convertDay, getDate, loadingSans } = useTableWeek();
  useEffect(() => {
    if (edit.date) {
      getWeek({
        item_id: id,
        date: edit.date,
      });
    } else {
      getWeek({
        item_id: id,
      });
    }
  }, []);
  useEffect(() => {
    if (multi && multi.status) {
      multi.clearTimes();
    }
  }, [status]);


  return (
    <BoxShadow style={{ padding: "0", margin: "0" }}>
      {needName && (
        <div className="row" style={{ borderBottom: "1px solid #e1e5eb" }}>
          <div className="col-10">
            <h6
              style={{
                fontSize: "1rem",
                lineHeight: "1.5rem",
                padding: "1rem",
              }} >
              {`جدول زمانی "${week && week.item && week.item.name}"`}
            </h6>
          </div>
        </div>
      )}

      <div
        style={{
          borderBottomStyle: !contractPage && "dashed",
          borderBlockColor: "rgb(221, 221, 221)",
        }}
      >
        {contract.status ? (
          <></>
        ) : (
          <div className="row justify-content-between py-3" style={{}}>
            <div className="col-4 d-flex align-items-center justify-content-start ">
              <h6
                style={{
                  cursor: "pointer",
                }}
                className="text-center mb-0 mr-2 d-flex align-items-center last-date"
                onClick={() => {
                  getWeek({
                    item_id: id,
                    date: !loadingWeek && week.key.lastweek,
                  });
                }}
              >
                {" "}
                {!loadingWeek && week.key.lastweek && (
                  <>
                    <AiOutlineRight /> {" هفته قبل"}
                  </>
                )}
              </h6>
            </div>
            <div className="mx-auto" style={{ fontSize: "10px", color: "#B6B6B6", fontWeight: "100" }}>
              امروز {new Date().toLocaleDateString('fa-IR-u-nu-latn')}
            </div>
            <div className="col-4 d-flex align-items-center justify-content-end">
              <h6
                style={{
                  cursor: "pointer",
                }}
                className="text-center mb-0 ml-2 d-flex align-items-center last-date"
                onClick={() => {
                  getWeek({
                    item_id: id,
                    date: !loadingWeek && week.key.nextweek,
                  });
                }}
              >
                {!loadingWeek && week.key.nextweek && (
                  <>
                    {" هفته بعد"}
                    <AiOutlineLeft />
                  </>
                )}
              </h6>
            </div>
          </div>
        )}
      </div>
      {loadingWeek ? (
        <Loading count={1} col={12} height={250} />
      ) : (
        <table
          className="table table-week"
          style={{ borderCollapse: "collapse", overflow: "hidden" }}
        >
          <thead
            style={{
              border: "none",
              borderBottomStyle: "dashed",
              borderBottomWidth: "1.6px",
              borderBottomColor: "#ddd",
            }}
          >
            <tr>
              <th scope="col"></th>
              {!loadingWeek &&
                days.map((day, key) => (
                  <th
                    key={key}
                    style={{
                      backgroundColor: "#fff",
                      borderBottomStyle: "dashed",
                    }}
                    className="th-head"
                  >
                    <div className="d-flex flex-column day-table">
                      <span style={{ color: "#444" }} className={"text-center " + (contractPage && "pb-1")}>
                        {convertDay(day)}
                      </span>

                      {!contractPage &&
                        <span style={{ color: "#999", fontSize: "12px" }} className="text-center" >
                          {getDate(day, week)}
                        </span>
                      }
                    </div>
                  </th>
                ))}
            </tr>
          </thead>
          <tbody>
            {!loadingWeek &&
              week.template.map((temp, count) => (
                <tr key={count}>
                  <th
                    style={{
                      padding: "0px",
                      verticalAlign: "middle",
                    }}
                    scope="row"
                    className="text-center"
                  >
                    <h6
                      className="time-table-span"
                      style={{
                        marginTop: "10px",
                      }}
                    >
                      {window.screen.width > 700
                        ? `${temp.time.split("-")[0]} تا ${temp.time.split("-")[1]
                        }`
                        : temp.time.split("-")[0]}
                    </h6>
                  </th>
                  {days.map((day, key) => (
                    <Sans
                      key={key}
                      loading={loadingSans}
                      data={week.times[day].times[count]}
                      day={getDate(day, week, true)}
                      options={week.option}
                      edit={edit}
                      contract={contract}
                      dayname={day}
                      multi={multi}
                      range={range}
                      status={status}
                      status2={status2}
                      isApp={isApp}
                    />
                  ))}
                </tr>
              ))}
          </tbody>
        </table>
      )}
    </BoxShadow>
  );
};

export default EditTimeTable;

export const Sans = ({
  data,
  day,
  loading,
  options,
  edit,
  contract = {},
  dayname,
  multi = {},
  range = {},
  status = false,
  status2 = false,
  isApp
}) => {
  const { statusHandler } = useTableWeek();
  const renderStyle = () => {
    if (statusHandler(data, day)) {
      if (contract && contract.status) {
        return {
          ...statusHandler(data, day, true)["style"],
          backgroundColor: contract.isInArray(data.id, dayname)
            ? "#79ffa4"
            : "#DDFFE8",
        };
      }
      else if (multi && multi.status && status) {
        return {
          ...statusHandler(data, day)["style"],
          backgroundColor: multi.isInArray(data.id, dayname, data.daykey)
            ? "#79ffa4"
            : statusHandler(data, day)["style"].background,
        };
      }
      else if (range && range.status && status2) {
        return {
          ...statusHandler(data, day)["style"],
          backgroundColor: multi.isInArray(data.id, dayname, data.daykey)
            ? "#79ffa4"
            : statusHandler(data, day)["style"].background,
        };
      }
      else {
        return { ...statusHandler(data, day)["style"] };
      }
    } else {
      return {};
    }
  };
  return (
    <td onClick={() => {
      if (multi && multi.status && status) {
        multi.toggleSelect(data.id, dayname, data.daykey, data);
      }
      else if (range && range.status && status2) {
        range.toggleSelect(data.id, dayname, data.daykey, data);
      }
      else if (edit && edit.method) {
        edit && edit.method(data, statusHandler(data, day).needData);
      } else if (contract && contract.status) {
        contract.toggleSelect(data.id, dayname);
      }
    }}
      className={`text-center sans-table ${statusHandler(data, day, true)["status"] && "sans-table-hover"}`}
      style={renderStyle()}
    >

      {statusHandler(data, day, contract.status).needData &&
        (data.second_price
          ? (
            <span
              style={{
                position: "relative",
                bottom: isApp ? "0" : "10px",
                color: "red",
                left: "-5px",
                fontSize: "10px",
              }}
            >
              {isApp
                ? "%"
                : "تخفیف"}

            </span>
          )
          : (+data.boxofficeprice > +data.price &&
            <span
              style={{
                position: "relative",
                bottom: isApp ? "0" : "10px",
                color: "red",
                left: "-5px",
                fontSize: "10px",
              }}>
              {isApp
                ? "%"
                : "تخفیف"}
            </span>
          ))
      }
      <span className="text-center">
        {loading.id == data.id && loading.day == data.day_id ? (
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
          />
        ) : (
          <CellRender
            time={data}
            data={statusHandler(data, day, contract.status)}
            options={options}
          />
        )}
      </span>
    </td>
  );
};

const CellRender = ({ data, time, options }) => {
  let elements = [
    { key: "needtitle", ele: "title" },
    { key: "needsession", ele: "session" },
    { key: "needgender", ele: "gender" },
  ];
  if (data.empty) {
    if (window.screen.width < 550 && data.text == "اتمام ظرفیت") {
      return "رزرو"
    }
    return data.text;
  } else if (data.pass) {
    return data.text;
  } else {
    return (
      <div className="d-flex flex-column">
        {elements.map(ele => {
          if (options[ele.key] == "true") {
            if (ele.ele == "gender") {
              return (
                <div className="my-1" key={ele.key}>
                  {GenderRender(time[ele.ele])}
                </div>
              );
            }
            return (
              <div className="my-1" key={ele.key}>
                {time[ele.ele]}
              </div>
            );
          }
        })}
        <div className="my-1">{RenderPrice(time)}</div>
      </div>
    );
  }
};
